export default __webpack_public_path__ + "static/bghouser-7714f3b3f346aa90f34938939ff28104.png";